exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1PdFPQEPKnRRno{margin:12px 40px 16px 56px;display:flex;grid-gap:8px;flex-wrap:wrap}._1Rso0xKnKltZ4p{color:#5e6c84;font-size:12px;font-weight:500;letter-spacing:.04em;margin-top:16px;text-transform:uppercase;line-height:20px;margin:0 8px 4px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}._3NN6fKSHFf-RrP{align-items:center;display:flex}._1hNC-JsqJ73j7G{margin:0!important;padding:0!important}.IzQZAgao_oZW6J{align-items:center;background-color:rgba(9,30,66,.04);border-radius:3px;display:inline-flex;flex-direction:row;margin:0 8px 0 0;max-width:304px;overflow:hidden;padding:6px 12px;text-overflow:ellipsis;white-space:nowrap}._3pj7nFujhpCHxI{border-radius:2px;font-size:12px;line-height:16px;margin:auto 0 auto 8px;padding:0 4px;text-transform:uppercase}._3pj7nFujhpCHxI._2bZ4OJ5y88q4-J{background-color:#5aac44;color:#fff}._3pj7nFujhpCHxI.r9t4g5gZEWPVpf{background-color:#e6c60d;color:#172b4d}._3pj7nFujhpCHxI._3POWJVdTTAlCd-{background-color:#cf513d;color:#fff}._3pj7nFujhpCHxI._7GJ0bu6vuWtgFU{background-color:#ec9488;color:#fff}", ""]);

// exports
exports.locals = {
	"dueDateSection": "_1PdFPQEPKnRRno",
	"heading": "_1Rso0xKnKltZ4p",
	"dueDateCheckboxAndBadge": "_3NN6fKSHFf-RrP",
	"dueDateCheckbox": "_1hNC-JsqJ73j7G",
	"dateBadge": "IzQZAgao_oZW6J",
	"dueDateStatusLozenge": "_3pj7nFujhpCHxI",
	"complete": "_2bZ4OJ5y88q4-J",
	"dueSoon": "r9t4g5gZEWPVpf",
	"dueNow": "_3POWJVdTTAlCd-",
	"duePast": "_7GJ0bu6vuWtgFU"
};